export enum SheetCellMenuOptions {
  Rename = 'Rename',
  Delete = 'Delete',
}
